import { defineMessages } from 'react-intl';

export default defineMessages({
  logout: {
    id: 'view.header.logout',
    defaultMessage: 'Log out',
  },
  languageLabel: {
    id: 'view.header.languageLabel',
    defaultMessage: 'Language',
  },
  en: {
    id: 'view.changeLanguage.en',
    defaultMessage: 'English',
  },
  fr: {
    id: 'view.changeLanguage.fr',
    defaultMessage: 'Français',
  },
  es: {
    id: 'view.changeLanguage.es',
    defaultMessage: 'Español',
  },
  de: {
    id: 'view.changeLanguage.de',
    defaultMessage: 'Deutsch',
  },
  it: {
    id: 'view.changeLanguage.it',
    defaultMessage: 'Italian',
  },
  pt: {
    id: 'view.changeLanguage.pt',
    defaultMessage: 'Portuguese',
  },
  nl: {
    id: 'view.changeLanguage.nl',
    defaultMessage: 'Dutch',
  },
  pl: {
    id: 'view.changeLanguage.pl',
    defaultMessage: 'Polish',
  },
  sv: {
    id: 'view.changeLanguage.sv',
    defaultMessage: 'Swedish',
  },
  fi: {
    id: 'view.changeLanguage.fi',
    defaultMessage: 'Finnish',
  },
  no: {
    id: 'view.changeLanguage.no',
    defaultMessage: 'Norwegian',
  },
  da: {
    id: 'view.changeLanguage.da',
    defaultMessage: 'Danish',
  },
  cs: {
    id: 'view.changeLanguage.cs',
    defaultMessage: 'Czech',
  },
  hu: {
    id: 'view.changeLanguage.hu',
    defaultMessage: 'Hungarian',
  },
  ro: {
    id: 'view.changeLanguage.ro',
    defaultMessage: 'Romanian',
  },
  el: {
    id: 'view.changeLanguage.el',
    defaultMessage: 'Greek',
  },
  tr: {
    id: 'view.changeLanguage.tr',
    defaultMessage: 'Turkish',
  },
  bg: {
    id: 'view.changeLanguage.bg',
    defaultMessage: 'Bulgarian',
  },
});
